<template>
  <div style="height: 100%;">
    <div v-if="moduletag === 2" style="padding-top: 20px;height: 50px;margin: 0 20px;color: #FFFFFF">
      <el-button type="warning" @click="addBtn()">录入</el-button>
      <span>楼栋/楼层：</span>
      <el-cascader v-fixZoom style="width: 320px" :options="orgOptions" class="input-el" clearable
                   v-model="orgid" :filterable="true" placeholder="请选择"
                   :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                   ref="orgOptions" @change="changeOrgData">
      </el-cascader>
      <el-button type="primary" @click="seeTableHealthPerson">查看</el-button>
    </div>
    <div v-if="moduletag === 1 || moduletag === 3" style="padding-top: 20px;height: 50px;margin: 0 20px;color: #FFFFFF">
      <el-row>
        <el-col :span="24">
          <el-button type="warning" @click="addBtn()">录入</el-button>
          <el-radio-group v-model="labelval">
            <el-radio-button :label="1">姓名查询</el-radio-button>
            <el-radio-button :label="0">条件查询</el-radio-button>
          </el-radio-group>
          <!--     组织     -->
          <el-cascader v-fixZoom v-if="labelval === 0" style="width: 320px" :options="orgOptions" class="input-el" clearable
                       v-model="orgid" :filterable="true" placeholder="请选择组织"
                       :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                       ref="orgOptions" >
          </el-cascader>
          <el-button v-if="labelval === 0" type="primary" @click="seeTableHomeHealthPerson">查看</el-button>
          <!--     姓名     -->
          <el-autocomplete v-fixZoom v-if="labelval === 1" style="width: 250px" class="inline-input input-el" v-model="personName"
                           :fetch-suggestions="querySearch" placeholder="请输入姓名选择服务对象" :trigger-on-focus="false" @input="handleInput" @select="handleSelect">
          </el-autocomplete>
          <el-button v-if="labelval === 1" type="primary" @click="searchPersonName()">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto">
      <div v-if="tableData.length === 0" style="text-align: center;color: #FFFFFF;height: 40px">暂无数据</div>
      <div class="box-item" v-for="item in tableData" :key="item.id">
        <div class="bg-health">
          <div v-if="moduletag === 1 || moduletag === 3" class="health-title" style="font-weight: 600">
            <img src="/static/health/homeicon.png">
            <span :title="item.porg_name + '/' + item.org_name + '/' + item.room + '/' + item.address">{{item.porg_name}} / {{item.org_name}} / {{item.room}} / {{item.address}}</span>
          </div>
          <div v-else class="health-title" style="font-weight: 600">
            <img src="/static/health/homeicon.png">
            <span :title="item.build_name + '/' + item.floor_name + '/' + item.home_name + '/' + item.bed_name">{{item.build_name}} / {{item.floor_name}} / {{item.home_name}} / {{item.bed_name}}</span>
          </div>
          <div style="height: calc(100% - 40px)">
            <div class="img-name">
              <div style="padding-top: 15px;height: 145px">
                <div v-if="item.photo_url !== ''" class="bg-photo">
                  <img :src="item.photo_url">
                </div>
                <div v-else class="bg-photo">
                  <img v-if="item.sex === '0'" src="static/nv.png">
                  <img v-else src="static/nan.png">
                </div>
              </div>
              <div style="height: 34px;font-size: 20px;color: #fefefe;text-align: center;font-family: TRENDS;overflow: hidden"><span>{{item.person_name}}</span></div>
              <div style="height: 24px;font-size: 14px;color: #fefefe;text-align: center;font-family: TRENDS;"><span>年龄：{{getAgeDesc(item.birthday)}}</span></div>
              <div style="height: 20px;font-size: 14px;color: #fefefe;text-align: center;font-family: TRENDS;"><span>性别：{{getSex(item.sex)}}</span></div>
            </div>
            <div class="health-list" style="color: #FFFFFF;">
              <el-row>
                <el-col :span="8">
                  <div class="bg-card">
                    <div style="height: 30px"><div class="item-num-title">体温</div><div class="item-num-icon"><img src="static/health/health_tiwen.png"></div></div>
                    <div style="height: 30px;line-height: 30px;font-weight: 700;color: #36cdff;font-size: 18px;margin: 0 10px">{{ item.tiwen }}℃</div>
                    <div style="height: 50px">
                      <div style="height: 13px;padding-top: 10px;">
                        <div :style="{marginLeft: item.tiwen === '-' ? '0%' : item.tiwen + '%'}" class="triangle-gray"></div>
                      </div>
                      <div style="margin: 0 5px">
                        <el-row>
                          <el-col :span="4"><div style="background-image: linear-gradient(#317cfc, #317cfc), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="7"><div style="background-image: linear-gradient(#53bbbd, #53bbbd), linear-gradient(#32b16c, #32b16c);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="13"><div style="background-image: linear-gradient(#fb651f, #fb651f), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="bg-card">
                    <div style="height: 30px"><div class="item-num-title">血压</div><div class="item-num-icon"><img src="static/health/health_xueya.png"></div></div>
                    <div style="height: 30px;line-height: 30px;font-weight: 700;color: #FFFFFF;font-size: 18px;margin: 0 10px">
                      <span style="color: #f5ce48">{{ item.xueya1 }}</span> / <span style="color:#2af694;">{{ item.xueya2 }}</span>
                    </div>
                    <div style="height: 50px">
                      <div style="height: 13px;padding-top: 10px;">
                        <div :style="{marginLeft: item.valPec}" class="triangle-gray"></div>
                      </div>
                      <div style="margin: 0 5px">
                        <el-row>
                          <el-col :span="4"><div style="background-image: linear-gradient(#5ea0fc, #5ea0fc), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="4"><div style="background-image: linear-gradient(#65ba5c, #65ba5c), linear-gradient(#32b16c, #32b16c);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="4"><div style="background-image: linear-gradient(#fec61f, #fec61f), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="4"><div style="background-image: linear-gradient(#fe9803, #fe9803), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="4"><div style="background-image: linear-gradient(#fe7701, #fe7701), linear-gradient(#32b16c, #32b16c);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                          <el-col :span="4"><div style="background-image: linear-gradient(#db4245, #db4245), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="bg-card">
                    <div style="height: 30px"><div class="item-num-title">心率</div><div class="item-num-icon"><img src="static/health/health_xinlv.png"></div></div>
                    <div style="height: 30px;line-height: 30px;font-weight: 700;color: #fe735c;font-size: 18px;margin: 0 10px">{{ item.xinlv }}</div>
                    <div style="height: 50px"></div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="bg-card">
                    <div style="height: 30px"><div class="item-num-title">血氧</div><div class="item-num-icon"><img src="static/health/health_xueyang.png"></div></div>
                    <div style="height: 30px;line-height: 30px;font-weight: 700;color: #5cf66a;font-size: 18px;margin: 0 10px">{{ item.xueyang }}</div>
                    <div style="height: 50px"></div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="bg-card">
                    <div style="height: 30px"><div class="item-num-title">血糖</div><div class="item-num-icon"><img src="static/health/health_xuetang.png"></div></div>
                    <div style="height: 30px;line-height: 30px;font-weight: 700;color: #dc9fff;font-size: 18px;margin: 0 10px">{{ item.xuetang }}</div>
                    <div style="height: 50px">
                      <div style="height: 13px;padding-top: 10px;">
                        <div :style="{marginLeft: item.valxuetang}" class="triangle-gray"></div>
                      </div>
                      <div style="margin: 0 5px">
                        <el-row>
                          <el-col :span="4"><div style="background-color: #db4245" class="item-div"></div></el-col>
                          <el-col :span="14"><div style="background-color: #16f0e3" class="item-div"></div></el-col>
                          <el-col :span="6"><div style="background-color: #fe9803" class="item-div"></div></el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="bg-card" style="cursor: pointer" @click="openHistory(item)">
                    <div style="height: 40px"></div>
                    <div style="height: 30px;line-height: 30px;font-weight: 700;color: #b2dcff;font-size: 18px;text-align: center">更多信息</div>
                    <div style="height: 40px"></div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom class="page-style" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[12, 24, 36, 96]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="typeShow" v-if="typeShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>健康数据类型列表</span>
        <div class="line-title"></div>
      </div>
      <health-type :healthObj="healthObj" @updateTable="updateTable"></health-type>
    </el-dialog>
    <!--  健康数据  -->
    <el-dialog :visible.sync="historyShow" v-if="historyShow" width="1300px" top="10vh"
               :show-close="true" center class="alarm-detail">
      <health-details :openHealthObj="openHealthObj" v-model="historyShow"></health-details>
    </el-dialog>
    <el-dialog :visible.sync="addShow" v-if="addShow" width="500px" top="7vh"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>录入健康数据</span>
        <div class="line-title"></div>
      </div>
      <add-health-data :addHealthObj="addHealthObj" v-model="addShow" @updateTable="seeTableHealthPerson"></add-health-data>
    </el-dialog>
    <el-dialog :visible.sync="bloodShow" v-if="bloodShow" width="500px" top="7vh"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>录入血压数据</span>
        <div class="line-title"></div>
      </div>
      <blood-pressure-select :addHealthObj="addHealthObj" v-model="bloodShow" @updateTable="seeTableHealthPerson"></blood-pressure-select>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryhealthdatatype, queryhealthqueryhomeperson,
  queryhealthqueryperson
} from '../../api/yanglaoyuan'
import healthType from './components/healthType'
import addHealthData from './components/addHealthData'
import bloodPressureSelect from './components/bloodPressureSelect'
import healthDetails from './components/healthDetails'
import {queryorg} from '../../api/organizer'
import {queryelderlyhasbed} from '../../api/yanglaoyuan/elderly'
import {searcholdperson} from '../../api/serviceObject'
export default {
  name: 'healthData',
  components: {healthType, addHealthData, bloodPressureSelect, healthDetails},
  data () {
    return {
      labelval: 1,
      orgOptions: [],
      orgid: '',
      orgArr: [],
      sendData: {
        build_id: 0,
        floor_id: 0,
        eid: 0,
        hid: 0
      },
      tabs: [
        {index: 0, name: '最新数据'},
        {index: 1, name: '历史数据'}
      ],
      indexActive: 0,
      elderlyArr: [],
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      entityId: 0,
      pageSize: 12,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      healthdatatype: [], // 健康数据类型
      typeShow: false,
      healthObj: {
        healthdatatype: []
      },
      historyShow: false,
      historyShow1: false,
      openHealthObj: {
        healthdatatype: [], // 健康数据类型
        personHealthRow: ''
      },
      addShow: false,
      addHealthObj: {
        orgid: '', // 是否已选择条件组织
        treeData: [], // 组织
        elderly: [], // 老人
        healthdatatype: [], // 录入数据
        mqttObj: {
          data: '104|68|59|FB:62:58:00:2A:8F'
        } // 血压测量选人
      },
      bloodShow: false,
      moduletag: '',
      personId: '',
      personName: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.golobleObject.updateTableAlarm = this.openHandle // 血压测量后,需要弹窗选择人员
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getOrgData()
    if (this.moduletag === 2) {
      this.getOldPersonData()
    }
  },
  mounted () {
  },
  methods: {
    // 组织
    getOrgData () {
      queryorg().then(res => {
        this.orgArr = this.clone(res.data.org)
        this.getOrTree()
        this.getHealthTypeData()
      }).catch(() => {})
    },
    getOrTree () {
      // 所属组织
      let lastLevel = 100
      const arr = []
      for (let i = 0; i < this.orgArr.length; i++) {
        let obj = this.orgArr[i]
        if (this.orgArr[i].level < lastLevel) {
          lastLevel = this.orgArr[i].level
        }
        if (this.moduletag === 2 && this.orgArr[i].org_type === 0) {
          obj.disabled = true
        } else {
          obj.disabled = false
        }
        arr.push(obj)
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      // console.log(999, arr, treeData)
      this.orgOptions = treeData
      this.addHealthObj.treeData = treeData
    },
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 楼栋/楼层
    changeOrgData (val) {
      let nodesObj = this.$refs['orgOptions'].getCheckedNodes()[0] ? this.$refs['orgOptions'].getCheckedNodes()[0].data : ''
      // console.log(nodesObj)
      this.sendData = {
        build_id: 0,
        floor_id: 0,
        eid: 0,
        hid: 0
      }
      if (nodesObj === '') {
        return
      }
      if (nodesObj.org_type === 1) {
        this.sendData.build_id = nodesObj.id
      } else if (nodesObj.org_type === 2) {
        this.sendData.floor_id = nodesObj.id
      }
    },
    // 健康数据类型
    getHealthTypeData () {
      queryhealthdatatype().then(res => {
        this.healthdatatype = res.data.healthdatatype
        this.addHealthObj.healthdatatype = res.data.healthdatatype
        this.openHealthObj.healthdatatype = res.data.healthdatatype
        if (this.moduletag === 1) {
          this.getTableHealthHomeData()
        } else if (this.moduletag === 2) {
          this.getTableHealthPerson()
        } else if (this.moduletag === 3) {
          this.getTableHealthHomeData()
        }
      })
    },
    // 查看按钮
    seeTableHealthPerson () {
      this.pageSize = 12
      this.currentPage = 1
      if (this.moduletag === 1) {
        this.seeTableHomeHealthPerson()
      } else if (this.moduletag === 2) {
        this.getTableHealthPerson()
      } else if (this.moduletag === 3) {
        this.getTableHealthHomeData()
      }
    },
    // 健康数据(养老院)
    getTableHealthPerson () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      queryhealthqueryperson(params, this.sendData).then(res => {
        this.getEnd(res.data.healthdata)
        this.totalCells = res.data.cnt
      })
    },
    // 最终数据
    getEnd (healthdata) {
      let arr = []
      for (let i = 0; i < healthdata.length; i++) {
        let obj = healthdata[i]
        obj.tiwen = this.getHealthKeyVal('体温', obj.person_health_value)
        obj.xueya1 = this.getHealthKeyVal('血压-高压', obj.person_health_value)
        obj.xueya2 = this.getHealthKeyVal('血压-低压', obj.person_health_value)
        obj.xinlv = this.getHealthKeyVal('心率', obj.person_health_value)
        obj.xueyang = this.getHealthKeyVal('血氧', obj.person_health_value)
        obj.xuetang = this.getHealthKeyVal('血糖', obj.person_health_value)
        obj.valPec = '0%' // 血压
        obj.valxuetang = '0%' // 血糖
        if (obj.xueya1 !== '-' && obj.xueya2 !== '-') {
          if (parseInt(obj.xueya1) <= 119 || parseInt(obj.xueya2) <= 79) {
            obj.valPec = '23%'
          } else if ((parseInt(obj.xueya1) > 119 && parseInt(obj.xueya1) <= 139) || (parseInt(obj.xueya2) > 79 && parseInt(obj.xueya2) <= 89)) {
            obj.valPec = '40%'
          } else if ((parseInt(obj.xueya1) > 139 && parseInt(obj.xueya1) <= 159) || (parseInt(obj.xueya2) > 89 && parseInt(obj.xueya2) <= 99)) {
            obj.valPec = '55%'
          } else if ((parseInt(obj.xueya1) > 159 && parseInt(obj.xueya1) <= 179) || (parseInt(obj.xueya2) > 99 && parseInt(obj.xueya2) <= 109)) {
            obj.valPec = '75%'
          } else if (parseInt(obj.xueya1) > 180 || parseInt(obj.xueya2) > 110) {
            obj.valPec = '90%'
          }
        }
        if (obj.xuetang !== '-') {
          if (obj.xuetang >= 3.9 && obj.xuetang <= 6.1) {
            obj.valxuetang = '46%'
          } else if (obj.xuetang >= 6.1 && obj.xuetang <= 7.8) {
            obj.valxuetang = '75%'
          } else if (obj.xuetang > 7.8) {
            obj.valxuetang = '90%'
          } else {
            obj.valxuetang = '13%'
          }
        }
        for (let j = 0; j < obj.person_health_value.length; j++) {
          obj.person_health_value[j].keyName = this.getHealthKey(obj.person_health_value[j].health_key_id)
        }
        arr.push(obj)
      }
      this.tableData = arr
    },
    // 服务对象（养老院）
    getOldPersonData () {
      let data = {
        e_id: this.$store.state.user.LoginResp.entity_id
      }
      queryelderlyhasbed({}, data).then(res => {
        this.addHealthObj.elderly = res.data.elderly
      })
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getHealthKeyVal (type, arr) {
      let val = ''
      let name = '-'
      for (let i = 0; i < this.healthdatatype.length; i++) {
        if (type === this.healthdatatype[i].key_name) {
          val = this.healthdatatype[i].id
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (val === arr[i].health_key_id) {
          if (parseFloat(arr[i].health_value)) {
            name = arr[i].health_value
          }
        }
      }
      return name
    },
    getHealthKey (id) {
      let name = id
      for (let i = 0; i < this.healthdatatype.length; i++) {
        if (id === this.healthdatatype[i].id) {
          name = this.healthdatatype[i].key_name
        }
      }
      return name
    },
    updateTable () {
      this.getHealthTypeData()
    },
    handleSizeChange (val) {
      console.log('pageSize', val)
      this.pageSize = val
      if (this.moduletag === 1) {
        this.getTableHealthHomeData()
      } else if (this.moduletag === 2) {
        this.getTableHealthPerson()
      } else if (this.moduletag === 3) {
        this.getTableHealthHomeData()
      }
    },
    handleCurrentChange (val) {
      // console.log('currentPage', val)
      this.currentPage = val
      if (this.moduletag === 1) {
        this.getTableHealthHomeData()
      } else if (this.moduletag === 2) {
        this.getTableHealthPerson()
      } else if (this.moduletag === 3) {
        this.getTableHealthHomeData()
      }
    },
    addBtn () {
      this.addHealthObj.orgid = this.orgid
      this.addShow = true
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let idNumber = item.idcard_num && item.idcard_num !== '' ? item.idcard_num : '--'
      return elderlyName + ' / ' + idNumber
    },
    openHistory (row) {
      this.openHealthObj.personHealthRow = row
      this.historyShow = true
    },
    openHandle (obj) {
      this.addHealthObj.mqttObj = obj
      this.bloodShow = true
    },
    // 查看（居家）
    seeTableHomeHealthPerson () {
      this.personId = ''
      this.personName = ''
      this.pageSize = 12
      this.currentPage = 1
      this.getTableHealthHomeData()
    },
    // 查询人名
    searchPersonName () {
      this.orgid = ''
      this.pageSize = 12
      this.currentPage = 1
      if (this.personId === '' || this.personId === null) {
        this.personName = ''
        this.$message({ message: '未选择服务对象。', type: 'warning' })
        this.seeTableHealthPerson()
      } else {
        this.getTableHealthHomeData()
      }
    },
    // 搜索人健康数据
    querySearch (queryString, cb) {
      let data = {
        lessname: queryString,
        page: 1,
        size: 9999
      }
      searcholdperson(data).then(res => {
        let arr = res.data.persons
        let arr1 = []
        for (let i = 0; i < arr.length; i++) {
          let obj = {
            value: arr[i].name + '(' + arr[i].h_address + ')',
            id: arr[i].id
          }
          arr1.push(obj)
        }
        if (arr1.length === 0) {
          this.$message({ message: '暂无该服务对象。', type: 'warning' })
        }
        cb(arr1)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    handleInput (value) {
      console.log(123, value)
      console.log(this.personId)
      if (value === '') {
        this.personId = ''
      }
    },
    handleSelect (item) {
      console.log('item', item, this.personId)
      this.personId = item.id
    },
    // 健康数据（居家）
    getTableHealthHomeData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        'pid': (this.personId === '' || this.personId === null) ? 0 : this.personId,
        'orgid': (this.orgid === '' || this.orgid === null) ? 0 : this.orgid,
        'hid': 0
      }
      queryhealthqueryhomeperson(params, data).then(res => {
        this.getEnd(res.data.healthdata)
        this.totalCells = res.data.cnt
      })
    }
  }
}
</script>

<style scoped>
.box-item{
  float: left;
  width: 33%;
}
.bg-health{
  margin: 10px;
  height: 325px;
  background: url("../../assets/health/bg_health_card.png") no-repeat;
  background-size: 100% 100%;
}
.health-title{
  font-family: PingFang-SC-Bold;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  color: #ffffff;
  height: 50px;
padding-top: 15px;
  margin: 0 15px;
}
.health-title img{
  vertical-align: middle;
}
.health-title span{
  vertical-align: middle;
}
.img-name{
  float: left;
  width: 150px;
  height: 100%;
}
.bg-photo{
  cursor: pointer;
  width: 102px;
  height: 132px;
  margin: auto;
  background: url("../../assets/health/bg_health_photo.png") no-repeat;
}
.bg-photo img{
  cursor: pointer;
  margin-top: 8px;
  margin-left: 11px;
  width: 90px;
  height: 116px;
}
.health-list{
  float: left;
  width: calc(100% - 150px);
  height: 100%;
}
.bg-card{
  height: 110px;
  margin: 5px;
  background-color: #020b1e;
  border-radius: 8px;
}
.item-num-title{
  float: left;
  margin-left: 10px;
  width: calc(100% - 40px);
  color: #b2dcff;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  font-weight: 600;
}
.item-num-icon{
  float: left;
  width: 20px;
  height: 40px;
  line-height: 40px;
  font-weight: 600;
}
.item-num-icon img{
  width: 20px;
}
.triangle-gray{
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #d1d1d1;
}
.item-div{
  height: 4px;
  border-radius: 2px;
  margin: 0 2px;
}
.bg-val-list{
  height: calc(100% - 70px);
  overflow-y: auto;
}
.bg-val-line{
  margin-top: 10px;
  margin-right: 15px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/health/bg_health_val.png") no-repeat;
  background-size: 100% 100%;
  color: #b2dcff;
}
.bg-val-line img,span{
  vertical-align: middle;
}
.open-health-title{
  height: 70px;
  line-height: 70px;
  text-align: center;
  background-image: linear-gradient(
    #86c5ff,
    #86c5ff),
  linear-gradient(
    #0077bf,
    #0077bf);
  background-blend-mode: normal,
  normal;
  border-radius: 10px 10px 0px 0px;
  color: #FFFFFF;
  font-size: 24px;
  letter-spacing: 2px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/healthData.vue